import { BaseElement } from '@adobe/edex/ui/components/base.element';
import { customElement, html } from '@adobe/edex/ui/edex-lit';
import { EdexTagName } from '@adobe/edex/ui/shared/constants';
import '@adobe/edex/ui/shared/components/otp-input/single-otp-input';
import styles from './otp-input.lit.scss';

const DEFAULT_NUM_INPUT = 6;

@customElement(EdexTagName.otpInput)
export class OtpInput extends BaseElement {
  static styles = styles;
  static get properties() {
    return {
      ...super.properties,
      numberInput: { type: Number },
      otpInput: { attribute: false },
      shouldAutoFocus: { type: Boolean },
      separator: { type: String },
      shouldAutoFoucs: { type: Boolean },
      activeInput: { type: Number },
    };
  }

  numberInput = DEFAULT_NUM_INPUT;
  inputType = 'number';
  activeInput = 0;
  otpInput = new Array(this.numberInput).fill('');
  shouldAutoFocus = true;
  separator = ' ';

  handlePaste = ({ detail: { event } }: CustomEvent) => {
    event.preventDefault();
    const text: string = event.clipboardData.getData('text/plain');
    const pasteArray = text.slice(0, this.numberInput - this.activeInput).split('');
    const currentCharsInOTP = this.otpInput.slice(0, this.activeInput);
    const combinedWithPastedData = currentCharsInOTP.concat(pasteArray);
    const emptyArray = new Array(this.numberInput - combinedWithPastedData.length).fill('');
    this.otpInput = [...combinedWithPastedData, ...emptyArray].slice(0, this.numberInput);
    this.focusInput(combinedWithPastedData.slice(0, this.numberInput).length);
    this.checkFilledAllInputs();
  };

  handleChange = ({ detail: { value } }) => {
    const { activeInput } = this;
    this.changeCodeAtFocus(value);
    this.focusInput(activeInput + 1);
  };

  changeCodeAtFocus(value) {
    const { activeInput } = this;
    const oldOtp = Object.assign([], this.otpInput);
    oldOtp[activeInput] = value;
    this.otpInput = [...oldOtp];
    this.checkFilledAllInputs();
  }

  clearInput() {
    this.otpInput = new Array(this.numberInput).fill('');
    this.activeInput = 0;
  }

  checkFilledAllInputs() {
    const { otpInput, numberInput } = this;
    if (otpInput.length === numberInput && !otpInput.includes('')) {
      this.emitEvent('on-complete', { value: otpInput.join('') });
    }
  }

  handleBlur = () => {
    this.activeInput = -1;
  };

  handleKeyDown = ({ detail: { event } }) => {
    const { activeInput } = this;
    switch (event.key) {
      case 'Backspace': {
        event.preventDefault();
        this.changeCodeAtFocus('');
        this.focusInput(activeInput - 1);
        break;
      }
      case 'Delete': {
        event.preventDefault();
        this.changeCodeAtFocus('');
        break;
      }
      case 'ArrowLeft': {
        event.preventDefault();
        this.focusInput(activeInput - 1);
        break;
      }
      case 'ArrowRight': {
        event.preventDefault();
        this.focusInput(activeInput + 1);
        break;
      }
      default:
        break;
    }
  };

  focusInput = (input) => {
    const { numberInput } = this;
    this.activeInput = Math.max(Math.min(numberInput - 1, input), 0);
  };

  render() {
    const { otpInput, inputType, numberInput, activeInput } = this;
    return html`
      <div class="otp-input">
        ${otpInput.map((value, index) => {
          return html`
            <edex-single-otp-input
              class=${this.className}
              .inputType=${inputType}
              .value=${otpInput[index]}
              .isLastChild=${index === numberInput - 1}
              .focusElement=${activeInput === index}
              @onPaste=${this.handlePaste}
              @onChange=${this.handleChange}
              @focusClick=${() => this.focusInput(index)}
              @onKeyDown=${this.handleKeyDown}
              @onBlur=${this.handleBlur}
            ></edex-single-otp-input>
          `;
        })}
      </div>
    `;
  }
}
